export default "__VITE_ASSET__DMKsgLwD__"